var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9596 46.3801H2.22965C1.96443 46.3801 1.71008 46.2747 1.52254 46.0872C1.335 45.8996 1.22965 45.6453 1.22965 45.3801V1.58006C1.22607 1.37673 1.28458 1.17715 1.39736 1.00793C1.51014 0.838703 1.67183 0.707886 1.86087 0.632922C2.04991 0.557959 2.25731 0.542411 2.45541 0.588354C2.65351 0.634297 2.8329 0.739545 2.96965 0.890063L46.6896 44.5801C46.871 44.7111 47.0031 44.8993 47.0649 45.1143C47.1267 45.3294 47.1146 45.559 47.0305 45.7663C46.9464 45.9737 46.7952 46.1469 46.6011 46.2581C46.4069 46.3694 46.1811 46.4123 45.9596 46.3801Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73031 37.4499C12.2403 37.4499 24.6703 36.9199 29.1603 37.4499C25.6303 35.2499 13.5803 23.6699 9.57031 18.6699C9.76031 19.8599 9.58031 34.5799 9.73031 37.4499Z",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8.22998H3.83",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15039 16.4702H3.83039",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15039 25.1499H3.83039",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15039 33.8398H3.83039",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15039 40.7803H3.83039",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8103 34.6699L35.7803 36.6399",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.96 28.8599L30.04 30.7299",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9102 22.6299L23.9902 24.4999",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8604 16.4102L17.9404 18.2802",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0196 11.4199L13.0996 13.2899",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 45.8,
    fill: "white",
    transform: "translate(0.5 0.580078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuild);
export default __webpack_public_path__ + "static/media/icon-build.1b14b65087a1a4f75d9c90d8f2d010ca.svg";
export { ForwardRef as ReactComponent };